/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { RootState } from '../store.typings';
import {
    AlertsExecutionsAction,
    AlertsExecutionActionType,
    fetchExecutionsPageSuccessAction,
    alertsExecutionsErrorAction,
} from '../actions/alertsExecutionsActions';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, interval, of } from 'rxjs';
import { alertsClient } from '../api/alerts/alertsClient';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';

type AlertsExecutionsEpic = Epic<AlertsExecutionsAction, AlertsExecutionsAction, RootState>;

export const fetchAlertsExecutionsEpic: AlertsExecutionsEpic = (action$, state$) => {
    return action$.pipe(
        ofType(
            AlertsExecutionActionType.OPEN_ALERTS_EXECUTIONS_PAGE,
            AlertsExecutionActionType.FETCH_ALERTS_EXECUTIONS_PAGE,
        ),
        switchMap(() => {
            const state = state$.value.alertsExecutionsReducer;
            const { AlertTemplateId } = state$.value.routerState.route.params;

            return from(alertsClient.getExecutionsList(+AlertTemplateId, state.executionsListSearchParams)).pipe(
                map((list) => fetchExecutionsPageSuccessAction(list)),

                catchError((err: AxiosError) => of(alertsExecutionsErrorAction(parseError(err)))),

                takeUntil(action$.pipe(ofType(AlertsExecutionActionType.CLOSE_ALERTS_EXECUTIONS_PAGE))),
            );
        }),
    );
};

const POLLING_INTERVAL = 10000;

export const fetchAlertsExecutionsByInterval: AlertsExecutionsEpic = (action$, state$) => {
    return action$.pipe(
        ofType(AlertsExecutionActionType.OPEN_ALERTS_EXECUTIONS_PAGE),
        switchMap(() => {
            return interval(POLLING_INTERVAL).pipe(
                switchMap(() => {
                    const state = state$.value.alertsExecutionsReducer;
                    const { AlertTemplateId } = state$.value.routerState.route.params;

                    return from(
                        alertsClient.getExecutionsList(+AlertTemplateId, state.executionsListSearchParams),
                    ).pipe(map((list) => fetchExecutionsPageSuccessAction(list)));
                }),
                takeUntil(action$.pipe(ofType(AlertsExecutionActionType.CLOSE_ALERTS_EXECUTIONS_PAGE))),
            );
        }),
    );
};
